<template>
  <div id="page-content" tabindex="-1">
    <span aria-label="Mobile Check In Page" aria-live="polite" role="contentinfo"></span>
    <p v-if="displaySuccessfulCheckIn" class="public-h5 font-weight-bold"
      :class="isRTLLanguage ? 'rtl' : 'normal'">
      {{ siteText.ui.successfulCheckInHeader }}
    </p>
    <p v-if="displayReservationNotFound" class="public-h5 font-weight-bold"
      :class="isRTLLanguage ? 'rtl' : 'normal'">
      {{ siteText.ui.reservationNotFoundHeader }}
    </p>
    <p v-if="displayReservationNotCloseEnough" class="public-h5 font-weight-bold"
      :class="isRTLLanguage ? 'rtl' : 'normal'">
      {{ siteText.ui.notCloseEnoughToHeader }}  {{ siteName }}
    </p>
    <p v-if="displayCheckInTooEarly" class="public-h5 font-weight-bold"
      :class="isRTLLanguage ? 'rtl' : 'normal'">
      {{ siteText.ui.tooEarlyForCheckInHeader }}
    </p>
    <p v-if="displayNoLocationAvailable" class="public-h5 font-weight-bold"
      :class="isRTLLanguage ? 'rtl' : 'normal'">
      {{ siteText.ui.noLocationAvailableHeader }}
    </p>
    <v-card v-if="!displaySuccessfulCheckIn">
      <v-card-text :class="isRTLLanguage ? 'rtl' : 'normal'">
        {{ siteText.ui.successfulCheckInLanguageText }}
      </v-card-text>
      <v-card-text class="centerContainer">
        <v-row>
          <!-- <v-select :label="siteText.ui.languageLabel" :class="isRTLLanguage ? 'v-text-field--reverse' : ''" filled
                         :items="languages" @change="languageChange" dense
          ></v-select> -->
          <!-- <vc-select class="vc-select" :searchable="false" :clearable="false" :options="languages" label="Name"
                     v-model="language" value="Code" @option:selected="languageChange"
                     :dropdown-should-open="(VCSelect)=>{return VCSelect.open;}"
          >
          </vc-select> -->
          <opus-select-only-drop-down
            :items="languages"
            select-name="languageSelect"
            item-label="Name"
            item-id="Code"
            :label="siteText.ui.languageLabel"
            :place-holder="siteText.ui.languageLabel"
            aria-label="Select a Language"
            @item:selected="languageChange"
            v-model="language"
            :class="isRTLLanguage ? 'rtl' : 'normal'"
          >
            <template #item="{ Code, Name }">
              <span :lang="Code">{{ Name }}</span>
            </template>
          </opus-select-only-drop-down>
        </v-row>
      </v-card-text>
    </v-card>
    <p></p>
    <v-card class="align-center justify-center" v-if="displaySuccessfulCheckIn">
      <v-card-text :class="isRTLLanguage ? 'rtl' : 'normal'">
        {{ siteText.ui.successfulCheckInText }}
      </v-card-text>
      <check-in-ticket
        :ticketNumber="ticketNumber"
        :bookingType="bookingType"
        :firstName="firstName"
        :lastName="lastName"
        :siteName="siteName"
        :formattedBookingDate="formattedBookingDate"
        :formattedCheckInDate="formattedCheckInDate"
        :serviceOne="serviceOne"
        :serviceTwo="serviceTwo"
        :formatedPhone="formatedPhone"
      >
      </check-in-ticket>
    </v-card>
    <v-card class="align-center justify-center" v-if="displayReservationNotFound"
      :class="isRTLLanguage ? 'rtl' : 'normal'">
      <v-card-text>
        {{ siteText.ui.reservationNotFoundText }} <strong> {{ reservationNumber }} </strong>.
      </v-card-text>
      <v-card-text>
        {{ siteText.ui.reservationNotFoundText2 }}
      </v-card-text>
    </v-card>
    <v-card class="d-flex align-center justify-center" v-if="displayReservationNotCloseEnough"
     :class="isRTLLanguage ? 'rtl' : 'normal'">
      <v-card-text>
      {{ siteText.ui.notCloseEnoughToText }} {{maxDistance}} {{ siteText.ui.notCloseEnoughToText2 }}
      {{ siteName }},&nbsp;{{ siteAddress }}
      {{ siteText.ui.notCloseEnoughToText3 }} {{ reservationNumber }}.
      </v-card-text>
    </v-card>
    <v-card class="d-flex align-center justify-center" v-if="displayCheckInTooEarly" 
      :class="isRTLLanguage ? 'rtl' : 'normal'">
        {{ siteText.ui.tooEarlyForCheckInText }} {{ reservationNumber }} 
        {{ siteText.ui.tooEarlyForCheckInText2 }} {{ formattedBookingDate }}.&nbsp;
        {{ siteText.ui.tooEarlyForCheckInText3 }} {{ checkInStartTime }}.&nbsp;
        {{ siteText.ui.tooEarlyForCheckInText4 }}
    </v-card>
    <v-card class="d-flex align-center justify-center" v-if="displayNoLocationAvailable" 
      :class="isRTLLanguage ? 'rtl' : 'normal'">
      <v-card-text>
        {{ siteText.ui.noLocationAvailableText }}
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import nyApi from '@/api/nyApi';
import CheckInTicket from '../components/CheckInTicket.vue';
import OpusSelectOnlyDropDown from "@/components/OpusSelectOnlyDropDown.vue";
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'MobileCheckInPage',
  components: {
    CheckInTicket,
    OpusSelectOnlyDropDown,
  },
  data: () => ({
    language: { Name:"English", Code:"en" },
    displaySuccessfulCheckIn: false,
    displayReservationNotFound: false,
    displayReservationNotCloseEnough: false,
    displayCheckInTooEarly: false,
    displayNoLocationAvailable: false,
    formattedCheckInDate: '',
    checkInStartTime: '',
    formattedBookingDate: '',
    ticketNumber: '',
    bookingType: 'checkin',
    firstName: '',
    lastName: '',
    formatedPhone: '',
    serviceOne: '',
    serviceTwo: '',
    siteName: '',
    siteAddress: '',
    formatedDateTime: '',
    options: { enableHighAccuracy: true, timeout: 30000, },
    maxDistance: 0
  }),
  computed: {
    ...mapGetters(['siteText']),
    ...mapGetters(['languages']),
    ...mapGetters({languageGetter: 'language'},),
    ...mapGetters(['reservationNumber','isRTLLanguage']),
  },
  async mounted() {
    //Set language based on current selected langauge//
    if (this.languages && this.languages.length > 0) {
      this.language = this.languages.find((e) => e.Code == this.languageGetter);
    }
    this.getLocation();
  },
  methods: {
    ...mapActions({
      languageAction: 'language',
    }),
    ...mapActions(['loading']),
    languageChange() {
      console.log(this.language.Code);
      this.languageAction({ value: this.language.Code });
    },
    showPosition(position) {
      console.log(position.coords.latitude);
      console.log(position.coords.longitude);
      this.checkInReservation(position.coords.latitude, position.coords.longitude);
    },
    showError(error) {
      this.loading(false)
      switch(error.code) {
        case error.PERMISSION_DENIED:
          console.log("User denied the request for Geolocation.");
          break;
        case error.POSITION_UNAVAILABLE:
          console.log("Location information is unavailable.");
          break;
        case error.TIMEOUT:
          console.log("The request to get user location timed out.");
          break;
        case error.UNKNOWN_ERROR:
          console.log("An unknown error occurred.");
          break;
      }
      this.checkInReservation(null, null);
    },
    getLocation() {
      if (navigator.geolocation) {
        this.loading(true);
        navigator.geolocation.getCurrentPosition(this.showPosition, this.showError, this.options);
      } else { 
        console.log("Geolocation is not supported by this browser.");
      }
    },
    async checkInReservation(latitude, longitude) {
      console.log(latitude, longitude);
      try {
        console.log(this.reservationNumber);
        this.loading(true);
        const response = await nyApi.CheckInReservation(this.reservationNumber, latitude, longitude);
        console.log(response);
        console.log(response.CheckInStatus);
        if (response.CheckInStatus === 0 || response.CheckInStatus === 3) {
          console.log('CheckInStatus OK successful! or CheckedIn successful!');
          this.displaySuccessfulCheckIn = true;
          this.ticketNumber = response.Data.TicketNumber;
          this.firstName = response.Data.FirstName;
          this.lastName = response.Data.LastName;
          this.siteName = response.Data.SiteName;
          this.formattedBookingDate  = response.Data.FormattedBookingDate;
          this.formattedCheckInDate = response.Data.FormattedCheckInDate;
          if (response.Data.ServiceTypeId !== null) {
            const serviceType = this.$store.getters.serviceType(response.Data.ServiceTypeId);
            console.log(serviceType);
            if (serviceType !== null) {
              this.serviceOne = serviceType.Name;
            } else {
              this.serviceOne = response.Data.ServiceType;
            }
          }
          if (response.Data.ServiceTypeId2 !== null) {
            const serviceType2 = this.$store.getters.serviceType(response.Data.ServiceTypeId2);
            console.log(serviceType2);
            if (serviceType2 !== null) {
              this.serviceTwo = serviceType2.Name;
            } else {
              this.serviceTwo = response.Data.ServiceType2;
            }
          }
        } else if (response.CheckInStatus === 1) {
          console.log('CheckInStatus Early');
          this.formattedBookingDate  = response.Data.FormattedBookingDate;
          this.checkInStartTime = response.Data.CheckInStartTime;
          this.displayCheckInTooEarly = true;
        } else if (response.CheckInStatus === 2) {
          console.log('CheckInStatus Late');
        } else if (response.CheckInStatus === 4) {
          console.log('CheckInStatus OutsideBusinessHours');
        } else if (response.CheckInStatus === 5) {
          console.log('CheckInStatus BookingNotFound');
          this.displayReservationNotFound = true;
        } else if(response.CheckInStatus === 6) {
          console.log('CheckInStatus Not Close Enough');
          this.siteName = response.Data.SiteName;
          this.siteAddress = response.Data.SiteAddress;
          this.maxDistance = response.Data.MaxDistance;
          this.displayReservationNotCloseEnough = true;
        } else if(response.CheckInStatus === 7) {
            //No location available//
            console.log('No coordinates available and location check is enabled for office');
            //use following message //
            //You must have your device's location turned on to check in.//
            this.displayNoLocationAvailable = true;
        }
      } catch (error) {
        console.log(error);
        console.log('CheckInStatus BookingNotFound');
        this.displayReservationNotFound = true;
      } finally {
        this.loading(false);
        console.log('Inside mobile check in page mounted finally');
      }
    }
  },
};
</script>
<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}

.v-card {
  min-height: 100px !important;
  padding: 20px !important;
}
</style>
